import React from 'react'
import PropTypes from 'prop-types'

import './styles'
import Models from '/models/index'

import ExternalLink from '/components/external-link'
import ListingPhoto from '/components/listing-photo'

import { Link }     from 'react-router-dom'

export default \
class ListingCard extends React.Component

  @propTypes:
    listing: PropTypes.instanceOf(Models.Listing).isRequired

  render: ->
    return null unless l = @props.listing
    <div className="ListingCard">
      <ListingPhoto image_url={l.image_url} listing={l} size={40}/>
      <div className="listing-details">
        <Link to={"/listings/#{l.id}"}>
          <span className="title">{l.title}</span>
        </Link> <ExternalLink url={l.url}/>
        <br/>
        {@props.children}
      </div>
    </div>
